import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, ListTodo, FolderKanban, Users, TrendingUp, Headphones } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import TaskDialog from "@/components/TaskDialog";

export default function QuickCreate() {
  const nav = useNavigate();
  const [taskOpen, setTaskOpen] = useState(false);
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button size="sm" className="gap-1.5" data-testid="quick-create-button">
            <Plus className="h-4 w-4" /> <span className="hidden sm:inline">Hızlı Ekle</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48">
          <DropdownMenuItem onClick={() => setTaskOpen(true)} data-testid="qc-task"><ListTodo className="h-4 w-4 mr-2" /> Görev</DropdownMenuItem>
          <DropdownMenuItem onClick={() => nav("/projects?new=1")} data-testid="qc-project"><FolderKanban className="h-4 w-4 mr-2" /> Proje</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <TaskDialog open={taskOpen} onOpenChange={setTaskOpen} />
    </>
  );
}
